import { CheckoutSession } from "checkout-query-client/hooks/use-checkout-session";

import { ChargeType } from "frontend-client";

import { getIsFeatureEnabled } from "splitio-loader/src/utils/get-split-io-flag";

interface Props {
  checkoutSession?: CheckoutSession;
  target?: string;
  merchantSurchargeFeeEnabled?: boolean;
}

export const useDoesSessionHaveSurcharge = ({
  checkoutSession,
  target,
  merchantSurchargeFeeEnabled,
}: Props) => {
  const isSurchargeFlagEnabled = getIsFeatureEnabled(
    target,
    "q4-surcharge-feature"
  );

  if (
    checkoutSession &&
    isSurchargeFlagEnabled &&
    checkoutSession.transactionCharges &&
    merchantSurchargeFeeEnabled
  ) {
    return checkoutSession.transactionCharges.some(
      (charge) => charge.chargeType === ChargeType.SURCHARGE
    );
  }
  return false;
};
